var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"left-arrow":""},on:{"click-left":_vm.back},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"font-semibold"},[_vm._v("得物")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }